<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld,

  },
  data() {
    return {
      userData: null,
    };
  },
  provide() {
    return {
      getUserData: () => JSON.parse(localStorage.getItem('user')),
      setUserData: (data) => (localStorage.setItem('user', JSON.stringify(data))),
      clearUserData: () => (localStorage.removeItem('user')),
      getCompanyData: () => JSON.parse(localStorage.getItem('companies')),
      setCompanyData: (data) => (localStorage.setItem('companies', JSON.stringify(data))),
      getSelectedCompany: () => JSON.parse(localStorage.getItem('company')),
      setSelectedCompany: (data) => (localStorage.setItem('company', JSON.stringify(data))),
    };
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  background: #f5f5fa;
}
</style>
